import React from "react";
import { Button } from "reactstrap";
import SvgImage from "../../../Icons/Icons";
import "./index.css";

function CardWallet(props) {
  const { value, name, onclick, title } = props;

  function handleOpt() {
    onclick(title);
  }

  return (
    <div className="btn-container">
      <div>
        <Button variant="light" className="outer" onClick={handleOpt}>
          <SvgImage name={name} classname="wallet-logo" />
        </Button>
      </div>
      <div>
        <p className="last-text">{title}</p>
      </div>
    </div>
  );
}

export default CardWallet;
